import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/technologies/skincare-ar"
    element={
      <DefaultBusinessLayout
        backgroundImage={require('../../../../assets/images/consumer/technologies/background.jpg')}
      />
    }
  >
    <Route path="business/technologies/skincare-ar" element={<AsyncPage />} />
  </Route>,
];
